var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-92c1ddc7-d07b-4935-90d5-03227b6292af",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-7a04dc8a-8464-4ab9-ad86-6978a4d65333 {\n        fill: #f2f2f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-7a04dc8a-8464-4ab9-ad86-6978a4d65333",
    d: "M16,18.78c-.41,0-.75-.34-.75-.75v-4.65c0-.41.34-.75.75-.75s.75.34.75.75v4.65c0,.41-.34.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-7a04dc8a-8464-4ab9-ad86-6978a4d65333",
    points: "18.39 14.07 16 9.93 13.61 14.07 18.39 14.07"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-7a04dc8a-8464-4ab9-ad86-6978a4d65333",
    d: "M20.76,22.02h-9.52c-1.26,0-2.28-1.02-2.28-2.28v-2.39c0-1.26,1.02-2.28,2.28-2.28h2.02c.55,0,1,.45,1,1s-.45,1-1,1h-2.02c-.16,0-.28.13-.28.28v2.39c0,.15.13.28.28.28h9.52c.16,0,.28-.13.28-.28v-2.39c0-.16-.13-.28-.28-.28h-2.02c-.55,0-1-.45-1-1s.45-1,1-1h2.02c1.26,0,2.28,1.02,2.28,2.28v2.39c0,1.26-1.02,2.28-2.28,2.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.8b4cdd8d77344cf6e94217743197634d.svg";
export { ForwardRef as ReactComponent };